module.exports = __webpack_public_path__ + "static/media/thesis.3cff2040.png";